// Formatting for the Open Market Commercial sales report.
//
// Money and volume follow the Finance workbook the board replaces: whole
// dollars and cyds to two places. Rev$/Cyd is the one figure in cents -- it is
// the unit-economics number leadership reads, and at ~$11 a rounding to whole
// dollars would erase every movement worth seeing.

export { fmtMoney, fmtNumber, fmtDate } from '../Inventory/format';

export function fmtCyds(n) {
  if (n === null || n === undefined) return '—';
  return Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

// A ratio with no denominator is "not measurable", never "$0.00": a cost center
// that hauled nothing did not haul for free.
export function fmtRate(n) {
  if (n === null || n === undefined || !Number.isFinite(Number(n))) return '—';
  return Number(n).toLocaleString('en-US', {
    style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2,
  });
}

export function fmtPct(n, digits = 0) {
  if (n === null || n === undefined || !Number.isFinite(Number(n))) return '—';
  return `${(Number(n) * 100).toFixed(digits)}%`;
}

// A line the mapping files could not place has no cost center. It is labelled
// for what it is rather than hidden or folded into a yard.
export function costCenterName(label) {
  return label ?? 'Unresolved';
}
